<template>
  <div class="footer-container">
    <div class="footer-content">
      <div class="content-main">
        <div class="main-nav">
          <div class="nav-item"
               v-for="(item, index) in $t('footer')"
               :key="index">
            <h2 class="item-title">{{ item.titleZH }}<span class="sub-title">{{ item.titleEN }}</span></h2>
            <div v-for="(item, index) in item.children"
                 :key="index">
              <router-link v-if="item.target === 'self'"
                           class="item-route"
                           :to="item.href">{{ item.name }}</router-link>
              <a v-else
                 class="item-route"
                 :href="item.link"
                 target="_blank">{{ item.name }}</a>
            </div>
          </div>
        </div>
        <div class="main-blog">
          <div class="main-consult">
            <div class="consult-item">
              <div class="item-title">业务咨询</div>
              <div class="item-content">
                <!-- <div class="tel-num">010-58650999</div> -->
                <div class="tel-num">17710166183</div>
                <div class="tel-num">010-50947770</div>
                <div class="time-long">8:30-17:30</div>
                <div class="tel-num" style="visibility: hidden">-</div>
                <div class="tel-num">海外业务：</div>
                <div class="time-long">Susie:+8613091439568</div>
                <div class="time-long">Liu:+8613220114637</div>
              </div>
            </div>
            <div class="consult-item">
              <div class="item-title"
                   style="visibility: hidden;">电子邮箱</div>
              <div class="item-content">
                <div class="tel-num">sales@tusuav.com</div>
                <div class="time-long">00:00-24:00</div>
              </div>
            </div>
            <div class="consult-item consult-item-h5">
              <div class="item-title">售后电话</div>
              <div class="item-content">
                <div class="tel-num">15810658990</div>
                <div class="time-long">08:30-17:30</div>
              </div>
            </div>
            <div class="guanwei-main">
              <img class="item-img"
                   src="/static/images/footer/guanwei.jpeg">
            </div>
          </div>
        </div>
      </div>
      <div class="main-copy">
        <div class="copy-content">
          <div class="content-item">
            <router-link class="item-img"
                         to="/">
              <img src="/static/images/footer/logo.png">
            </router-link>
            <a class="item-link"
               href="javascript:;">隐私权政策·使用条款</a>
          </div>
          <div class="content-item">
            <span class="item-span">Copyright ©2019-2023 远度互联科技 保留所有权利</span>
            <a class="item-link"
               href="https://beian.miit.gov.cn/"
               target="_blank">京ICP备2020036765号</a>
            <a class="item-link"
               href="https://beian.miit.gov.cn/"
               target="_blank">京公网安备1102292000358</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data () {
    return {};
  },
  created () { }
};
</script>

<style scoped lang="stylus">
.footer-container {
  min-width: 1200px;
  margin: 0 auto;
  background: #161616;

  .footer-content {
    .content-main {
      display: flex;
      height: 350px;
      max-width: 1280px;
      // min-width: 1024px;
      margin: 0 auto;
      padding: 40px 0;
      box-sizing: border-box;

      .main-nav {
        width: 55%;

        .nav-item {
          width: 120px;
          display: inline-block;
          vertical-align: top;

          .item-title {
            color: #999999;
            padding-bottom: 20px;

            .sub-title {
              display: block;
              font-size: 12px;
              padding: 2px 0;
            }
          }

          .item-route {
            display: block;
            padding: 10px 0;
            color: #fff;

            .prefix {
              color: #007BE7;
              margin-right: 4px;
            }
          }
        }
      }

      .main-blog {
        width: 45%;
        color: #999;

        .main-website {
          padding-bottom: 20px;

          .website-item {
            display: inline-block;
            height: 30px;
            margin-right: 10px;

            .icon-img {
              vertical-align: top;
              height: 100%;
            }
          }
        }

        .main-consult {
          position: relative;

          .consult-item {
            display: inline-block;
            padding-right: 20px;
            vertical-align: top;

            .item-title {
              padding-bottom: 20px;
            }

            .item-content {
              line-height: 22px;
            }
          }

          .guanwei-main {
            position: absolute;
            top: 0;
            right: 0;

            .item-img {
              width: 100px;
              height: 100px;
            }
          }
        }
      }
    }
  }

  .main-copy {
    // height: 44px;
    height: 120px;
    background: #212121;
    color: rgba(255, 255, 255, 0.4);

    .copy-content {
      max-width: 1280px;
      // min-width: 1024px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;

      .content-item {
        flex: 1;
        padding: 15px 0;

        .item-img {
          display: inline-block;
          width: 106px;
          height: 14px;
          margin-right: 20px;
          vertical-align: top;

          img {
            width: 100%;
          }
        }

        .item-link, .item-span {
          line-height: 14px;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.4);
        }

        .item-span {
          padding-right: 20px;
        }

        &:last-child {
          text-align: right;
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .footer-container {
    min-width: 100%;

    .footer-content {
      .content-main {
        display: block;
        height: auto;
        max-width: 100%;

        .main-nav {
          width: 100%;

          .nav-item {
            width: 120px;
            display: inline-block;
            vertical-align: top;
            text-align: center;
            padding-bottom: 20px;
          }
        }

        .main-blog {
          width: 100%;

          .main-website {
            padding: 0 20px;

            .website-item {
              display: inline-block;
              width: 60px;
              height: 30px;
              margin-right: 0;
              margin-bottom: 20px;

              .icon-img {
                vertical-align: top;
                height: 100%;
              }
            }
          }

          .main-consult {
            padding: 0 20px;

            .consult-item-h5 {
              padding-top: 20px;
            }

            .guanwei-main {
              display: block;
              position: unset;
              margin-top: 40px;
            }
          }
        }
      }
    }

    .main-copy {
      height: auto;

      .copy-content {
        max-width: 100%;
        display: block;

        .content-item {
          padding: 10px 20px;

          .item-link, .item-span {
            line-height: 16px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.4);
            white-space: nowrap;
          }

          &:last-child {
            text-align: left;

            .item-link {
              // display: block;
              // padding-top: 5px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue